export const PATHS = {
	LOGIN_PAGE: `/login`,
	AUTH_CODE_PAGE: `/auth/code`,
	// AUTH_PAGE: `/auth`,
	HOME_PAGE: `/`,
	SIGN_IN_PAGE: `/sign-in`,
	DASHBOARD_PAGE: `/dashboard`,
	GENERAL_SETTINGS_PAGE: `/general-settings`,
	SUPPORTED_COUNTRIES_PAGE: `/supported-countries`,
	CONTRACT_PAGE: `/contract`,
	ORDERS_PAGE: `/orders`,
	ORDER_PAGE: `/order/:orderId`,
	REFUNDS_PAGE: `/refunds`,
	REFUND_PAGE: `/refund/:orderId/:refundId`,
	// CONFIRMED_ORDERS_PAGE: `/orders/confirmed`,
	// ORDERS_FULFILLMENT_PAGE: `/orders/fulfillment`,
	// ORDERS_RETURNS_PAGE: `/orders/returns`,
	// ORDER_DISCOUNTS_PAGE: `/orders/discounts`,
	INVOICES_PAGE: `/invoices`,
	SALES_REPORTS_PAGE: `/sales-reports/:typeOfReport`,
	VAT_REPORTS_PAGE: '/vat-reports/:typeOfReport',
	VAT_CORRECTIONS_PAGE: `/vat-corrections`,
	NOTIFICATION_SETTINGS_PAGE: `/notification-settings`,
	USER_MANAGEMENT_PAGE: `/user-management`,
	PAYMENT_METHODS_PAGE: '/payment-methods',
	SECURITY_SETTINGS_PAGE: `/security-settings`,
	PRICING_PAGE: `/pricing`,
	INTEGRATIONS_PAGE: `/integrations`,
	UPLOADED_SALES_REPORTS_PAGE: `/integrations-sales-report`,
	SHIPMENTS_PAGE: `/shipments`,
	SHIPMENT_PAGE: `/shipment/:orderId`,
	HMRC_AUTH_REDIRECT: `/hmrc-auth-redirect`,
	GPSR_SERVICE_PAGE: `/gpsr-service`,
	CHANGE_GPSR_SERVICE_PAGE: `/gpsr-service/change-gpsr-service`,
	GPSR_SERVICE_SKU_PAGE: `/gpsr-service/:productTypeId`,
	EUDR_SERVICE_PAGE: `/eudr-service`,
	EUDR_FILES_PAGE: `/eudr-files`,
	EU_DDP_PAGE: `/eu-ddp`,
	EU_DDP_ORDER_PAGE: `/eu-ddp/:orderId`,
	EPR_PPWR_PAGE: `/epr-ppwr`,
	PPWR_MANUAL_REPORT_PAGE: `/ppwr-manual-report`,
	PPWR_PACKING_PROFILE_PAGE: `/ppwr-packing-profile`,
	PPWR_COUNTRY_EXCLUSION_PAGE: `/ppwr-country-exclusion`,
	SHOPIFY_DEV_APPS_PAGE: `/shopify-dev-app`,
	SHOPIFY_DEV_APP_PAGE: `/shopify-dev-app/:appId`,
	INACTIVITY_PAGE: `/inactivity`,
	PUBLIC_ATTACHMENT_UPLOAD_PAGE: `/upload-file/:hash`,
	DOWNLOAD_ORDERS_EXPORT_PAGE: `/download-orders-export/:hash`,
};

export const ORDERS_PATHS = {
	CONFIRMED_ORDERS_PAGE: `confirmed`,
	ORDERS_FULFILLMENT_PAGE: `fulfillment`,
	ORDERS_RETURNS_PAGE: `returns`,
	ORDER_DISCOUNTS_PAGE: `discounts`,
};
